'use client';

import { c as _c } from "react/compiler-runtime";
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';
import { cn } from '@/lib/utils';
const Progress = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let ref;
  let value;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = value;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    value = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = `translateX(-${100 - (value || 0)}%)`;
  let t3;
  if ($[7] !== t2) {
    t3 = <ProgressPrimitive.Indicator className="h-full w-full flex-1 bg-primary transition-all" style={{
      transform: t2
    }} />;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t3 || $[13] !== value) {
    t4 = <ProgressPrimitive.Root ref={ref} value={value} className={t1} {...props}>{t3}</ProgressPrimitive.Root>;
    $[9] = props;
    $[10] = ref;
    $[11] = t1;
    $[12] = t3;
    $[13] = value;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };